import e from "./AsyncApiCodeExample.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                        */
import t from "../../_virtual/_plugin-vue_export-helper.js";
//#region src/code-example/components/AsyncApiCodeExample.vue
var n = /*#__PURE__*/ t(e, [["__scopeId", "data-v-41f67ce2"]]);
//#endregion
export { n as default };

//# sourceMappingURL=AsyncApiCodeExample.vue.js.map